import React, { FC } from "react"

import { DeviceDocument } from "../../../../contexts/devices-context"
import OperatingTimeModuleSettings, { WittyPiScheduleAttribute } from "./OperatingTimeModuleSettings"
import useModuleAttributes from "../../hooks/useModuleAttributes"

type DeviceOperatingTimeSettingsCardProps = {
    device: DeviceDocument
}

const _DeviceOperatingTimeModuleSettings: FC<DeviceOperatingTimeSettingsCardProps> = ({ device }) => {
    const attrs = useModuleAttributes<"schedule", WittyPiScheduleAttribute>(device, "wittypi")

    return (
        <OperatingTimeModuleSettings
            attrs={attrs}
            organisation={device.organisation}
            group={device.group}
            device={device}
            coordinates={device.coordinates}
        />
    )
}

export default _DeviceOperatingTimeModuleSettings
